<template>
  <body v-if="!defaultHidden" style="z-index: 1; background: rgba(0,0,0,0.4);">
    <div class="app-container shadow-7">
      <slot name="header" />
      <slot />
      <div class="app-container__footer">
        <slot name="footer" />
      </div>
    </div>
    <!-- <q-inner-loading
      :showing="false"
      label="お待ちください"
      label-class="text-black"
      label-style="font-size: 1.5rem"
    /> -->
  </body>
</template>

<script>
import { defineComponent, computed, watch, ref } from 'vue'
export default defineComponent({
  name: "Root",
  props: {
    hide: {
      type: [String, Boolean],
      default: () => 'false',
    },
  },
  setup(props, {_}) {
    const defaultHidden = computed(() => props.hide === 'true');
    return {
      defaultHidden
    }
  }
})
</script>
